(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanaro-floating-inquiry"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sanaro-floating-inquiry')) {
customElements.define('sanaro-floating-inquiry', class extends HTMLElement {
connectedCallback() {
this.abort = new AbortController();
const signal = this.abort.signal;
const details = this.querySelector('.sanaro-float__details');
const trigger = this.querySelector('.sanaro-float__trigger');
const close = () => { details.open = false; trigger.focus(); };
this.querySelector('[data-sanaro-close]').addEventListener('click', close, { signal });
details.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(details.open)), { signal });
document.addEventListener('keydown', event => { if (event.key === 'Escape' && details.open) { event.preventDefault(); close(); } }, { signal });
document.addEventListener('click', event => {
const link = event.target instanceof Element ? event.target.closest('[data-sanaro-quote]') : null;
if (!link) return;
event.preventDefault();
details.open = true;
this.querySelector('[name="contact[name]"]').focus({preventScroll:true});
}, {signal});
if (this.querySelector('[data-sanaro-result]')) details.open = true;
}
disconnectedCallback() { this.abort?.abort(); }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanaro-rfq-modal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sanaro-rfq-modal')) {
  class SanaroRfqModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.initLeadTracking();
      this.onClick = (event) => {
        const trigger = event.target.closest?.('[data-sanaro-rfq-open], [data-sanaro-quote]');
        if (trigger) {
          event.preventDefault();
          this.opener = trigger;
          if (!this.dialog.open) this.dialog.showModal();
          document.documentElement.classList.add('sanaro-rfq-open');
          return;
        }
        if (event.target.closest?.('[data-sanaro-rfq-close]')) {
          event.preventDefault();
          this.dialog.close();
        }
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      };
      this.onClose = () => {
        document.documentElement.classList.remove('sanaro-rfq-open');
        if (this.opener?.isConnected) this.opener.focus({preventScroll: true});
      };
      document.addEventListener('click', this.onClick);
      this.dialog.addEventListener('close', this.onClose);
    }

    initLeadTracking() {
      this.leadRoots = new Map();
      this.scanLeadRoots = () => {
        this.dialog.querySelectorAll('shopify-forms-embed').forEach((host) => {
          const root = host.shadowRoot;
          if (!root || this.leadRoots.has(root)) return;
          const state = { armed: false, sent: false };
          const check = () => {
            if (!state.armed || state.sent || root.querySelector('form')) return;
            const success = [...root.querySelectorAll('h1, h2, h3')].some((heading) =>
              ['Enquiry received', '询价已收到'].includes(heading.textContent.trim())
            );
            if (!success) return;
            state.sent = true;
            this.publishLeadSuccess();
          };
          const submit = () => {
            if (!state.sent) state.armed = true;
          };
          root.addEventListener('submit', submit, true);
          const observer = new MutationObserver(check);
          observer.observe(root, { subtree: true, childList: true, characterData: true });
          this.leadRoots.set(root, { observer, submit });
        });
      };
      this.scanLeadRoots();
      this.leadScanTimer = setInterval(this.scanLeadRoots, 1000);
    }
    publishLeadSuccess() {
      let attempts = 0;
      const publish = () => {
        if (window.Shopify?.analytics?.publish) {
          window.Shopify.analytics.publish('sanaro:rfq_success', { form_id: '1204940' });
          return;
        }
        if (++attempts < 30 && this.isConnected) this.leadPublishTimer = setTimeout(publish, 1000);
      };
      publish();
    }
    disconnectedCallback() {
      clearInterval(this.leadScanTimer);
      clearTimeout(this.leadPublishTimer);
      this.leadRoots?.forEach(({ observer, submit }, root) => {
        observer.disconnect();
        root.removeEventListener('submit', submit, true);
      });
      this.leadRoots?.clear();
      document.removeEventListener('click', this.onClick);
      this.dialog?.removeEventListener('close', this.onClose);
      document.documentElement.classList.remove('sanaro-rfq-open');
    }
  }
  customElements.define('sanaro-rfq-modal', SanaroRfqModal);
}

  } catch(e) { console.error(e); }
})();
})();
